import { render, staticRenderFns } from "./Verification.vue?vue&type=template&id=d20cd352&scoped=true&"
import script from "./Verification.vue?vue&type=script&lang=js&"
export * from "./Verification.vue?vue&type=script&lang=js&"
import style0 from "./Verification.vue?vue&type=style&index=0&id=d20cd352&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d20cd352",
  null
  
)

export default component.exports